import type { LoaderProps } from '../Icons/LoadingSpinner';
import LoadingSpinner from '../Icons/LoadingSpinner';
import { usePathname } from 'next/navigation';
import { ROUTES } from '@/config/routes';
import { LoadingSpinnerIcon } from '@/design-system';
import React from 'react';

const Loader = (props: LoaderProps) => {
  const pathname = usePathname();

  if (pathname?.startsWith(ROUTES.OHS_HUB)) {
    return (
      <div className="h-screen w-screen flex items-center justify-center">
        <LoadingSpinnerIcon className="animate-spin" />
      </div>
    );
  }

  return <LoadingSpinner position={props.position} />;
};

export default Loader;
